import React from 'react';
import { List, Stack, Typography } from '@mui/material';
import { MedicalReferralItem } from 'API/Home/userUpdates';
import { OneOrTwoButtons } from 'Components/OneOrTwoButtons';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { useNavigate } from 'react-router-dom';
import { ReferralListItem } from '../ReferralListItem';
import { isDesktop } from 'react-device-detect';

interface IData {
  data: { Title: string; Items: MedicalReferralItem[] };
}

export const ReferralList = ({ data }: IData) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Home).userUpdates;

  const navigate = useNavigate();

  return (
    <Stack
      p={'40px 32px 48px'}
      bgcolor={'white'}
      height={'100%'}
      borderRadius={'16px'}
      justifyContent={'space-between'}
    >
      <Stack gap={'24px'}>
        <Typography variant='h5'>{data.Title}</Typography>
        <Stack gap={'8px'}>
          <List sx={{ overflowY: 'auto', maxHeight: '285px' }}>
            {data.Items.map((item: MedicalReferralItem, index: number) => (
              <ReferralListItem index={index} item={item} />
            ))}
          </List>
        </Stack>
      </Stack>
      <OneOrTwoButtons
        width='max-content'
        leftButton={{
          label: dictionary.allMedicalReferralsLabel,
          onClick: () => navigate('/medical-referrals'),
        }}
      />
    </Stack>
  );
};
